import { Form, FormItemProps, InputNumber, InputNumberProps } from 'antd';

interface Props extends InputNumberProps {
  readonly label?: string;
  readonly errorMessage?: string;
  readonly formItemProps?: FormItemProps;
}

export const AntInputNumber = ({ style, id, label, value = '', errorMessage, formItemProps, ...props }: Props) => {
  return (
    <Form.Item
      label={label}
      {...formItemProps}
      style={style}
      htmlFor={id}
      help={errorMessage}
      validateStatus={errorMessage ? 'error' : undefined}
    >
      <InputNumber {...props} style={{ width: '100%' }} min={0} step={0.01} id={id} precision={2} value={value} />
    </Form.Item>
  );
};
